import fileDownload from "js-file-download";
import driversService from "../shared/services/driversService";

const REQUEST_DRIVERS = "REQUEST_DRIVERS";
const RESPONSE_DRIVERS = "RESPONSE_DRIVERS";
const REQUEST_DRIVERS_FAULURE = "REQUEST_DRIVERS_FAULURE";

const requestDriversAction = () => {
  return {
    type: REQUEST_DRIVERS,
  };
};

const responseDriversAction = (data) => {
  return {
    type: RESPONSE_DRIVERS,
    data,
  };
};

const requestDriversFailureAction = () => {
  return {
    type: REQUEST_DRIVERS_FAULURE,
  };
};

const getDrivers = (options) => {
  return (dispatch) => {
    dispatch(requestDriversAction());

    driversService
      .getDrivers(options)
      .then((result) => {
        dispatch(responseDriversAction(result.data));
      })
      .catch((error) => {
        dispatch(requestDriversFailureAction());
      });
  };
};

const SELECT_DRIVER = "SELECT_DRIVER";

const selectDriverAction = (data) => {
  return {
    type: SELECT_DRIVER,
    data,
  };
};

const selectDriver = (driver) => {
  return (dispatch) => {
    dispatch(selectDriverAction(driver));
    dispatch(selectDriverForUnitsAction(null));
  };
};

const SELECT_DRIVER_FOR_UNITS = "SELECT_DRIVER_FOR_UNITS";

const selectDriverForUnitsAction = (data) => {
  return {
    type: SELECT_DRIVER_FOR_UNITS,
    data,
  };
};

const selectDriverForUnits = (driver) => {
  return (dispatch) => {
    dispatch(selectDriverAction(null));
    dispatch(selectDriverForUnitsAction(driver));
  };
};

const REQUEST_CREATE_DRIVER = "REQUEST_CREATE_DRIVER";
const RESPONSE_CREATE_DRIVER = "RESPONSE_CREATE_DRIVER";
const REQUEST_CREATE_DRIVER_FAULURE = "REQUEST_CREATE_DRIVER_FAULURE";

const requestCreateDriverAction = () => {
  return {
    type: REQUEST_CREATE_DRIVER,
  };
};

const responseCreateDriverAction = (data) => {
  return {
    type: RESPONSE_CREATE_DRIVER,
    data,
  };
};

const requestCreateDriverFailureAction = () => {
  return {
    type: REQUEST_CREATE_DRIVER_FAULURE,
  };
};

const createDriver = (options) => {
  return (dispatch) => {
    dispatch(requestCreateDriverAction());

    const categories = Object.keys(options.categories).reduce((accumulator, current) => {
      return parseInt(accumulator) + parseInt(current);
    }, 0);

    driversService
      .createDriver({ ...options, categories })
      .then((result) => {
        options.id = result.data;
        dispatch(selectDriverAction(options));
        dispatch(responseCreateDriverAction(options));
      })
      .catch((error) => {
        dispatch(requestCreateDriverFailureAction());
      });
  };
};

const REQUEST_UPDATE_DRIVER = "REQUEST_UPDATE_DRIVER";
const RESPONSE_UPDATE_DRIVER = "RESPONSE_UPDATE_DRIVER";
const REQUEST_UPDATE_DRIVER_FAULURE = "REQUEST_UPDATE_DRIVER_FAULURE";

const requestUpdateDriverAction = () => {
  return {
    type: REQUEST_UPDATE_DRIVER,
  };
};

const responseUpdateDriverAction = (data) => {
  return {
    type: RESPONSE_UPDATE_DRIVER,
    data,
  };
};

const requestUpdateDriverFailureAction = () => {
  return {
    type: REQUEST_UPDATE_DRIVER_FAULURE,
  };
};

const updateDriver = (options) => {
  return (dispatch) => {
    dispatch(requestUpdateDriverAction());

    const categories = Object.keys(options.categories).reduce((accumulator, current) => {
      return parseInt(accumulator) + parseInt(current);
    }, 0);

    driversService
      .updateDriver({ ...options, categories })
      .then((result) => {
        dispatch(selectDriverAction(options));
        dispatch(responseUpdateDriverAction(options));
      })
      .catch((error) => {
        dispatch(requestUpdateDriverFailureAction());
      });
  };
};

const REQUEST_DELETE_DRIVER = "REQUEST_DELETE_DRIVER";
const RESPONSE_DELETE_DRIVER = "RESPONSE_DELETE_DRIVER";
const REQUEST_DELETE_DRIVER_FAULURE = "REQUEST_DELETE_DRIVER_FAULURE";

const requestDeleteDriverAction = () => {
  return {
    type: REQUEST_DELETE_DRIVER,
  };
};

const responseDeleteDriverAction = (data) => {
  return {
    type: RESPONSE_DELETE_DRIVER,
    data,
  };
};

const requestDeleteDriverFailureAction = () => {
  return {
    type: REQUEST_DELETE_DRIVER_FAULURE,
  };
};

const deleteDriver = (options) => {
  return (dispatch) => {
    dispatch(requestDeleteDriverAction());

    driversService
      .deleteDriver(options)
      .then((result) => {
        dispatch(selectDriverAction(null));
        dispatch(responseDeleteDriverAction(options));
      })
      .catch((error) => {
        dispatch(requestDeleteDriverFailureAction());
      });
  };
};

const REQUEST_CREATE_DRIVER_UNIT = "REQUEST_CREATE_DRIVER_UNIT";
const RESPONSE_CREATE_DRIVER_UNIT = "RESPONSE_CREATE_DRIVER_UNIT";
const REQUEST_CREATE_DRIVER_UNIT_FAULURE = "REQUEST_CREATE_DRIVER_UNIT_FAULURE";

const requestCreateDriverUnitAction = () => {
  return {
    type: REQUEST_CREATE_DRIVER_UNIT,
  };
};

const responseCreateDriverUnitAction = (data, unitId) => {
  return {
    type: RESPONSE_CREATE_DRIVER_UNIT,
    data,
    unitId,
  };
};

const requestCreateDriverUnitFailureAction = () => {
  return {
    type: REQUEST_CREATE_DRIVER_UNIT_FAULURE,
  };
};

const createDriverUnit = (options, unitId) => {
  return (dispatch) => {
    dispatch(requestCreateDriverUnitAction());

    driversService
      .createDriverUnit({ unitId: unitId, driverId: options.id })
      .then((result) => {
        dispatch(responseCreateDriverUnitAction(options, unitId));
      })
      .catch((error) => {
        dispatch(requestCreateDriverUnitFailureAction());
      });
  };
};

const REQUEST_DELETE_DRIVER_UNIT = "REQUEST_DELETE_DRIVER_UNIT";
const RESPONSE_DELETE_DRIVER_UNIT = "RESPONSE_DELETE_DRIVER_UNIT";
const REQUEST_DELETE_DRIVER_UNIT_FAULURE = "REQUEST_DELETE_DRIVER_UNIT_FAULURE";

const requestDeleteDriverUnitAction = () => {
  return {
    type: REQUEST_DELETE_DRIVER_UNIT,
  };
};

const responseDeleteDriverUnitAction = (driverId, unitId) => {
  return {
    type: RESPONSE_DELETE_DRIVER_UNIT,
    driverId,
    unitId,
  };
};

const requestDeleteDriverUnitFailureAction = () => {
  return {
    type: REQUEST_DELETE_DRIVER_UNIT_FAULURE,
  };
};

const deleteDriverUnit = (options, unitId) => {
  return (dispatch) => {
    dispatch(requestDeleteDriverUnitAction());

    driversService
      .deleteDriverUnit({ unitId: unitId, driverId: options.id })
      .then((result) => {
        dispatch(responseDeleteDriverUnitAction(options.id, unitId));
      })
      .catch((error) => {
        dispatch(requestDeleteDriverUnitFailureAction());
      });
  };
};

const REQUEST_DOWNLOAD_DRIVERS = "REQUEST_DOWNLOAD_DRIVERS";
const RESPONSE_DOWNLOAD_DRIVERS = "RESPONSE_DOWNLOAD_DRIVERS";
const REQUEST_DOWNLOAD_DRIVERS_FAULURE = "REQUEST_DOWNLOAD_DRIVERS_FAULURE";

const requesDownloadDriverstAction = () => {
  return {
    type: REQUEST_DOWNLOAD_DRIVERS,
  };
};

const responseDownloadDriversAction = () => {
  return {
    type: RESPONSE_DOWNLOAD_DRIVERS,
  };
};

const requestDownloadDriversFailureAction = () => {
  return {
    type: REQUEST_DOWNLOAD_DRIVERS_FAULURE,
  };
};

const downloadDrivers = (companyTitle) => {
  return (dispatch) => {
    dispatch(requesDownloadDriverstAction());

    driversService
      .downloadDrives()
      .then((result) => {
        fileDownload(result.data, `${companyTitle}.xlsx`)
        dispatch(responseDownloadDriversAction());
      })
      .catch((error) => {
        dispatch(requestDownloadDriversFailureAction());
      });
  };
};

export {
  REQUEST_DRIVERS,
  RESPONSE_DRIVERS,
  REQUEST_DRIVERS_FAULURE,
  getDrivers,
  SELECT_DRIVER,
  selectDriver,
  REQUEST_CREATE_DRIVER,
  RESPONSE_CREATE_DRIVER,
  REQUEST_CREATE_DRIVER_FAULURE,
  createDriver,
  REQUEST_UPDATE_DRIVER,
  RESPONSE_UPDATE_DRIVER,
  REQUEST_UPDATE_DRIVER_FAULURE,
  updateDriver,
  REQUEST_DELETE_DRIVER,
  RESPONSE_DELETE_DRIVER,
  REQUEST_DELETE_DRIVER_FAULURE,
  deleteDriver,
  SELECT_DRIVER_FOR_UNITS,
  selectDriverForUnits,
  REQUEST_CREATE_DRIVER_UNIT,
  RESPONSE_CREATE_DRIVER_UNIT,
  REQUEST_CREATE_DRIVER_UNIT_FAULURE,
  createDriverUnit,
  REQUEST_DELETE_DRIVER_UNIT,
  RESPONSE_DELETE_DRIVER_UNIT,
  REQUEST_DELETE_DRIVER_UNIT_FAULURE,
  deleteDriverUnit,
  REQUEST_DOWNLOAD_DRIVERS,
  RESPONSE_DOWNLOAD_DRIVERS,
  REQUEST_DOWNLOAD_DRIVERS_FAULURE,
  downloadDrivers,
};
